import { createContext } from 'react';

interface Context {
  notify: (message: string, isError: boolean) => void;
}

export default createContext<Context>({
  notify: () => {},
});
